import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    if (!email.trim()) return;

    setStatus('loading');
    try {
      const resp = await fetch('https://readdy.ai/api/form/d9u506tca23r0tr1aqn0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
      const responseText = await resp.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (resp.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败';
        if (String(serverMsg).includes('spam')) {
          setStatus('success');
          setEmail('');
        } else {
          setStatus('error');
          setErrorMsg(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络异常，请稍后再试');
    }
  };

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-lg mx-auto text-center">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
          <i className="ri-mail-send-line text-3xl text-primary-500"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
          慢时光通讯
        </h2>
        <p className="text-sm text-foreground-500 leading-relaxed mb-8">
          每周一封温暖的邮件，分享慢生活灵感、精选文章和治愈瞬间。<br />
          不打扰，只陪伴。
        </p>

        {status === 'success' ? (
          <div className="bg-secondary-50 border border-secondary-200/70 rounded-lg p-6">
            <p className="text-foreground-800 font-medium mb-1">感谢订阅！</p>
            <p className="text-sm text-foreground-500">每周的温暖来信会准时送达你的邮箱。</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row gap-3">
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              className="flex-1 px-5 py-3 rounded-full border border-background-200/70 bg-background-50 text-sm text-foreground-800 placeholder-foreground-300 focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-300 transition-all"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap disabled:opacity-60"
            >
              {status === 'loading' ? '提交中...' : '订阅'}
            </button>
          </form>
        )}
        {status === 'error' && (
          <p className="text-xs text-accent-500 mt-3">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}